<template>
  <div class="group-manage conmon-top" style="position: relative;">
    <el-container>
      <!--左侧分组-->
      <el-aside class="left-aside-type" width="220px">
        <div class="group-search">
          <el-input
            placeholder="请输入内容"
            v-model.trim="groupName"
            @keyup.enter.native="searchQrcodeType">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer" @click="searchQrcodeType"></i>
          </el-input>
        </div>
        <el-menu
          default-active="0"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          text-color="#333"
          active-text-color="#333">
          <el-menu-item :class="item.choosen ? 'getIt' : ''" :index="index + ''" v-for="(item, index) in groups" :key="index" @click="chooseQrcodeType(index, item)">
            <div class="menu-btn" v-if="item.catename !== '全部'">
              <i v-if="butsObj.edit_group" @click="editGroupTypeItem(item)" class="el-icon-edit" style="margin-right: 0"></i>
              <i v-if="butsObj.del_group" @click="deleteQrCodeTypeItem(item)" class="el-icon-close" style="margin-right: 0"></i>
            </div>
            <span class="menu-title" :title="item.catename">{{ item.catename }}</span>
          </el-menu-item>
          <div v-if="butsObj.add_group" class="add-group-btn" @click="addGroup">
            <i class="el-icon-circle-plus-outline" title="添加分组"></i>
          </div>
        </el-menu>
      </el-aside>
      <!--右侧列表-->
      <div style="padding: 0;width: calc(100% - 200px)">
        <div class="base-input ovf-hd" style="margin-bottom: 10px;">
          <el-collapse-transition>
            <div class="search-content common-search-formtype" style="line-height: 48px">
              <div class="demo-input-suffix" style="text-align: left; margin-left: 32px">
                公众号切换：
                <el-select v-model="original_id" placeholder="请选择" @change="changePub">
                  <el-option
                    v-for="item in publicNumber"
                    :key="item.original_id"
                    :label="item.nick_name"
                    :value="item.original_id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-collapse-transition>
        </div>
        <div class="base-input ovf-hd" style="margin-top: 0 !important">
          <el-row class="search-title" v-if="!isHigher" style="width: 100%;">
            <el-col :span="4" class="table-title">
              <i class="el-icon-search" style="font-weight: bold;"></i>
              <span class="order-list-search-span">筛选查询</span>
            </el-col>
            <el-col :span="20" class="text-align-right">
              <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
              <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
              <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
              <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
              <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
            </el-col>
          </el-row>
          <el-row class="search-content common-search-formtype" v-show="hide" v-if="!isHigher">
            <el-col class="text-align-left common-search-formtype">
              <span style="margin-left: 26px">名称：</span>
              <el-input placeholder="二维码名称" clearable @keyup.enter.native="searchLoad" v-model.trim="searchTmp.title"></el-input>
              <span style="margin-left: 20px">来源：</span>
              <el-select filterable v-model="searchTmp.source_id" placeholder="全部" style="margin-right: 10px;" class="customer-manage-search-item"
                         @visible-change="visibleChangeOne" @focus="focusWayOne" ref="selectOne">
                <el-option
                  v-for="item in sourceOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
          <el-row class="search-title common-table-top" style="padding-right:0">
            <el-col :span="4" class="table-title">
              <i class="el-icon-document" style="font-weight: bold;"></i>
              <span>数据列表</span>
            </el-col>
            <el-col :span="20" class="text-align-right safari-input-style">
              <span style="margin-left: 20px">移到分组：</span>
              <el-select class="common-search-formtype" style="margin-right: 10px" v-model="cate_id"
                         @change="confirmChooseGroupType" :disabled="checkAll" placeholder="请选择目标分组">
                <el-option
                  v-for="item in cateOptions"
                  :key="item.id"
                  :label="item.catename"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-button v-if="butsObj.add" class="add-btn btn-right" type="primary" @click="qrcodeAdd">新建二维码</el-button>
            </el-col>
          </el-row>
          <!--数据列表-->
          <div class="table-content table-checkbox-style">
            <el-table
              v-if="showCustomer === true"
              key="tableData"
              id="tableData"
              ref="multipleTable"
              :data="tableData"
              class="table"
              v-loading="loading"
              @selection-change="handleSelectionChange">
              <template slot="empty">
                <div class="newTableEmpty">暂无数据，去<span @click="qrcodeAdd">新建</span></div>
              </template>
              <el-table-column
                class="qrcode-table-checkbox"
                fixed
                type="selection"
                width="50">
              </el-table-column>
              <el-table-column
                prop="title"
                fixed
                label="二维码名称"
                width="150">
                <template slot-scope="scope">
                  {{ scope.row.title }}
                </template>
              </el-table-column>
              <el-table-column
                prop="nick_name"
                label="公众号"
                width="">
                <template slot-scope="scope">
                  {{ scope.row.wechat_public?scope.row.wechat_public.nick_name:'' }}
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="来源"
                width="">
                <template slot-scope="scope">
                  {{ scope.row.customer_source? scope.row.customer_source.name:''}}
                </template>
              </el-table-column>
             <!--  <el-table-column
                label="来源内容"
                width="">
                <template slot-scope="scope">
                  {{ scope.row.sourcetxt }}
                </template>
              </el-table-column> -->
              <el-table-column
                label="二维码"
                width="">
                <template slot-scope="scope">
                  <img  @click="showQRcode(scope.row.qrcodepath)"
                        src="/static/img/erweima.png" width="30px" v-if="butsObj.show_qrcode">
                  <img v-else
                        src="/static/img/erweima.png" width="30px">
                    <!-- <img :src="scope.row.qrcodepath" style="width:50px;height:50px;" @click="showQRcode(scope.row.qrcodepath)"> -->
                </template>
              </el-table-column>
              <el-table-column
                label="访问人数"
                width="">
                <template slot-scope="scope">
                  {{ scope.row.scan_num }}
                </template>
              </el-table-column>
              <el-table-column
                label="回复类型"
                width="">
                <template slot-scope="scope">
                  <div v-if="scope.row.reply === 0">
                    无回复
                  </div>
                  <div v-if="scope.row.reply === 1">
                    文本
                  </div>
                  <div v-if="scope.row.reply === 2">
                    图片
                  </div>
                  <div v-if="scope.row.reply === 4">
                    微页面
                  </div>
                  <div v-if="scope.row.reply === 5">
                    外部页
                  </div>
                  <div v-if="scope.row.reply === 6">
                    会员注册
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="创建时间"
                 width="155">
                <template slot-scope="scope">
                  {{ scope.row.create_time | formatDate }}
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="100">
                <template slot-scope="scope">
                  <router-link v-if="butsObj.edit" :to="{ name: 'qrcodeEdit', query: { id: scope.row.id, original_id: original_id, public_id: public_id, modelId: modelId }}"
                               class="op-link editColor" style="margin-left: 0;text-decoration: none">
                    编辑
                  </router-link>
                  <div class="op-link deleteColor" v-if="butsObj.del" @click="deleteItem(scope.row)">
                    删除
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="table-foot" style="text-align: right">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-size="limit"
              :current-page="page"
              layout="total, prev, pager, next, jumper"
              :total="totalCount">
            </el-pagination>
          </div>
      </div>
    </el-container>
    <!--添加二维码分组弹窗-->
    <el-dialog class="cellDialog base-dialog" title="创建二维码分组" :visible.sync="adddialog" width="520px">
      <el-form ref="addForm" :model="addForm" :rules="rules">
        <el-form-item label="分组名称:" :label-width="addLabelWidth" prop="catename">
          <el-input class="stockInput" type="text" v-model="addForm.catename" auto-complete="off" placeholder="输入二维码分组名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="adddialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="submitForm('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--编辑二维码分组弹窗-->
    <el-dialog class="cellDialog base-dialog" title="编辑二维码分组" :visible.sync="editdialog" width="520px">
      <el-form ref="editForm" :model="editForm">
        <el-form-item label="分组名称:" :label-width="addLabelWidth">
          <el-input class="stockInput" type="text" v-model="editForm.catename" auto-complete="off" placeholder="输入二维码分组名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="editdialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" style="margin-right: 32px" @click="confirmEdit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog class="cellDialog base-dialog" title="二维码" :visible.sync="QRViewDialog" width="600px">
      <img :src="QRImage" class="qrcode-image">
    </el-dialog>
  </div>
</template>

<script>
import { getQrCodeCateList, getQrCodeList, addQrCodeType, editQrCodeType, deleteQrCodeType, deleteQrcode, getCateData, getSourceData, ChooseGroup } from '@/api/customer.js'
import HigherSearch from './../common/higher-search.vue'
import { butonsList, getMenId } from '@/api/analyse.js'
export default {
  name: 'weixinManage',
  data () {
    return {
      inputFlagOne: null,
      modelId: '',
      loading: true,
      original_id: '',
      publicNumber: [], // 公众号
      public_id: '',
      QRImage: '',
      QRViewDialog: false,
      date: '',
      cate_id: '',
      queryGroups: [],
      tableData: [],
      customerData: [],
      sourceOptions: [],
      cateOptions: [],
      showCustomer: true,
      limit: 10,
      totalCount: 0,
      adddialog: false,
      editdialog: false,
      addForm: {
        catename: ''
      },
      editForm: {
        catename: ''
      },
      addLabelWidth: '80px',
      dialogType: 0,
      editId: '',
      editGroupTypeId: '',
      page: 1,
      hide: true,
      closeChoose: '收起筛选',
      searchTmp: {
        title: '',
        source_id: '',
        cate_id: ''
      },
      search: {
        title: '',
        source_id: '',
        cate_id: ''
      },
      groupName: '',
      newGroupName: '',
      groups: [],
      deleteArrayIds: [],
      checkAll: true,
      isHigher: false,
      createGroupType: 0,
      qrcodeTypeIndex: 0,
      isDisabled: false,
      lastId: 0,
      allTerms: {},
      forSonTerms: [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              relationship: '',
              value: null,
              selectedOptions: ['attr', 'realname@input']
            }
          ]
        }
      ],
      len: 0,
      mircoPageArray: [],
      rules: {
        catename: [
          { required: true, message: '请输入分组名称', trigger: 'blur' }
        ]
      },
      butsObj: { // button按钮列表
        add_group: false,
        del: false,
        edit: false,
        add:false,
        show_qrcode:false,
        edit_group: false,
        del_group: false,
        move_to_group: false
      }
    }
  },
  mounted () {
    rule.publicNumber((res) => {
      for (let item of res.data.data.list) {
        if (item.is_disable === 0) {
          this.publicNumber.push(item)
          if (item.is_default === 1) {
            this.public_id = item.id
            this.modelId = item.model_id
            this.original_id = item.original_id
          }
        }
      }
      this.load()
    })
    this.loadQrCodeCate()
    this.getButtonsList()
  },
  computed: {
    Newitems() {
      let _this = this
      let Newitems = []
      if (_this.groupName === '') {
        return
      }
      _this.groups.map(function(item) {
        if (item.catename.search(_this.groupName) != -1) {
          Newitems.push(item)
        }
      })
      return Newitems
    }
  },
  components: {
  },
  methods: {
    focusWayOne () {
      if (this.inputFlagOne) {
        this.$refs['selectOne'].blur()
      }
    },
    visibleChangeOne (val) {
      setTimeout(()=> {
        this.inputFlagOne = val
      },0)
    },
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    // 切换公众号
    changePub(val) {
      for (let one of this.publicNumber) {
        if (one.original_id === val) {
          this.public_id = one.id
          this.modelId = one.model_id
        }
      }
      this.load()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmAdd()
        } else {
          return false
        }
      })
    },
    searchLoad() {
      this.search = JSON.parse(JSON.stringify(this.searchTmp))
      this.page = 1
      this.load()
    },
    showQRcode(value) {
      this.QRViewDialog = true
      this.QRImage = value
    },
    qrcodeAdd() {
      this.$router.push({path: '/home/qrcode-add', query: { original_id: this.original_id, public_id: this.public_id, modelId: this.modelId }})
    },
    // 获取子组件的查询条件
    getAllTerms(value) {
      this.allTerms = value
    },
    // 添加群组
    saveQuery() {
      if (this.allTerms.termsGroup.length === 1) {
        if (this.allTerms.termsGroup[0].terms[0].value == null) {
          _g.toastMsg('error', '请选择条件')
          return
        }
      }
      for (let item of this.allTerms.termsGroup) {
        for (let one of item.terms) {
          let str = one.selectedOptions[1].split('@')
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str[0]
        }
      }// 防止重复点击
      this.isDisabled = true
      addGroup(this.newGroupName, this.createGroupType, this.allTerms).then((res) => {
        if (res.data.code === 0) {
          this.isDisabled = false
          this.isHigher = false
          this.newGroupName = ''
          this.showCustomer = true
          this.newGroupName = ''
          this.load()
          _g.toastMsg('success', '添加群组成功')
        } else {
          this.isDisabled = false
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 查找二维码类型
    searchQrcodeType() {
      let flag = 0
      for (let i in this.groups) {
        this.groups[i].choosen = false
        for (let j in this.Newitems) {
          if (this.groups[i].id === this.Newitems[j].id) {
            this.groups[i].choosen = true
            flag++
          }
        }
      }
      if (flag === 0) {
        _g.toastMsg('error', '没有匹配的分组')
      }
    },
    // 点选二维码类型
    chooseQrcodeType(index, item) {
      this.qrcodeTypeIndex = index
      this.search.cate_id = item.id
      this.load()
    },
    // 取消创建群组
    cancelCreate() {
      this.isHigher = false
      this.createGroupType = 0
      this.page = 1
      this.showCustomer = true
      this.newGroupName = ''
      this.customerData = []
      this.load()
    },
    // 确认移到分组
    confirmChooseGroupType() {
      ChooseGroup(this.cate_id, this.deleteArrayIds).then((res) => {
        if (res.data.code === 0) {
          this.load()
          this.cate_id = ''
          _g.toastMsg('success', '移动分组成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 全选
    handleSelectionChange(val) {
      this.deleteArrayIds = []
      for (let i in val) {
        this.deleteArrayIds.push(val[i].id)
      }
      if (parseInt(val.length) > 0) {
        if(this.butsObj.move_to_group) {
          this.checkAll = false
        } else {
          this.checkAll = true
        }
      } else {
        this.checkAll = true
      }
    },
    // 列表删除
    deleteItem(item) {
      this.$confirm('确认删除该二维码?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteQrcode(item.id).then((res) => {
          if (res.data.code === 0) {
            this.load()
            _g.toastMsg('success', '二维码删除成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      if (this.showCustomer === false) {
        this.lastId = this.customerData[this.customerData.length - 1].id
        this.preView()
      } else {
        this.load()
      }
    },
    handleCurrentChange(page) {
      this.page = page
      if (this.showCustomer === false) {
        this.lastId = this.customerData[this.customerData.length - 1].id
        this.preView()
      } else {
        this.load()
      }
    },
    // 获取查询 来源 的数据
    getSource() {
      getSourceData().then((res) => {
        if (res.data.code === 0) {
          this.sourceOptions.push({
            name: '全部',
            id: ''
          })
          for (let item of res.data.data.list) {
            this.sourceOptions.push({
              id: item.id,
              name: item.name
            })
          }
        }
      })
    },
    // 获取查询 分组 的数据
    getCate() {
      getCateData().then((res) => {
        if (res.data.code === 0) {
          this.cateOptions = res.data.data.list
        }
      })
    },
    // 加载数据列表
    load() {
      console.log(this.search)
      this.loading = true
      getQrCodeList({
        params: {
          original_id: this.original_id,
          page: this.page,
          limit: this.limit,
          search: this.search
        }
      }).then((res) => {
        if (res.data.code === 0) {
          this.tableData = res.data.data.list
          this.totalCount = res.data.data.total
          this.len = 0
          for (let item of this.tableData) {
            this.len = this.len + item.length
          }
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 加载二维码分组列表load
    loadQrCodeCate() {
      getQrCodeCateList(this.page, this.search).then((res) => {
        if (res.data.code === 0) {
          res.data.data.list.unshift({ id: '', catename: '全部' })
          for (let item of res.data.data.list) {
            item.choosen = false
          }
          this.groups = res.data.data.list
        }
      })
    },
    // 请求分组类型数组(给select用)
    loadGroupTypes() {
      getQrCodeTypeList().then((res) => {
        if (res.data.code === 0) {
          this.queryGroups = res.data.data.list
        }
      })
    },
    // 左侧分组导航
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    // 收起筛选和展开筛选
    closeAndOpen() {
      if (this.hide === true) {
        this.closeChoose = '展开筛选'
        this.hide = false
      } else {
        this.closeChoose = '收起筛选'
        this.hide = true
      }
    },
    // 添加二维码分组
    addGroup() {
      this.adddialog = true
      this.addForm.catename = ''
    },
    // 删除二维码分组
    deleteQrCodeTypeItem(item) {
      this.$confirm('确认删除该二维码分组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteQrCodeType(item.id).then((res) => {
          if (res.data.code === 0) {
            this.loadQrCodeCate()
            _g.toastMsg('success', '删除二维码分组成功')
            this.adddialog = false
            this.getCate()
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 编辑二维码分组
    editGroupTypeItem(item) {
      this.editdialog = true
      this.editForm.catename = item.catename
      this.editForm.id = item.id
    },
    confirmEdit() {
      editQrCodeType(this.editForm.catename, this.editForm.id).then((res) => {
        if (res.data.code === 0) {
          this.loadQrCodeCate()
          _g.toastMsg('success', '编辑二维码分组成功')
          this.editdialog = false
          this.getCate()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 添加二维码分组弹窗 确定
    confirmAdd() {
      addQrCodeType(this.addForm.catename).then((res) => {
        if (res.data.code === 0) {
          this.loadQrCodeCate()
          _g.toastMsg('success', '添加二维码分组成功')
          this.adddialog = false
          this.getCate()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    }
  },
  created() {
    this.loadQrCodeCate()
    this.getSource()
    this.getCate()
  }
}
</script>

<style scoped>
  .left-aside-type{
    overflow-x: hidden;
    max-width: 200px;
    min-width: 185px;
  }
    .el-menu-item .menu-btn{display:none;float:right;}
    .el-menu-item:hover .menu-btn{display: block}
    .disabled{
        background: #ccc!important;
    }
    .getIt{
        color: #FF5500!important;
    }
    .cancelCreate{
        float: right;
        margin-right: 10px;
        color: #ff7373;
        cursor: pointer;
    }
    .el-menu-vertical-demo {
        position: relative;
        max-height: 850px;
        width:100%;
        border-right: none;
        overflow-y: auto;
        overflow-x:hidden;
        margin-bottom: 0;
        padding-bottom: 0
    }
    .group-search{
        height: 60px;
        background: #fff;
        border-bottom: 1px solid #e5e5e5;
    }
    .el-radio-group{
        margin-top: -13px;
    }
    .text-align-left{
        text-align: left;
    }
    .text-align-right{
        text-align: right;
    }
    .table-title{
        text-align: left;
    }
/*    .search-title{
        background:#ecf6ff;
        border:1px solid #ebebeb;
        height:60px;
        padding:10px;
        line-height: 40px;
    }*/
    .el-input--prefix .el-input__inner{
        padding-left: 40px !important;
    }
    .table-content {
      width: 100%;
      overflow-x: auto;
      min-width: 500px;
    }
    .qrcode-image {
      width: 435px;
      height: 435px;
    }
    .table {
      /*min-width: 800px;*/
    }
</style>
